import React from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import block from 'bem-cn';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import SVG from 'components/SVG';

import { actions as appActions } from 'features/app';
import { NotificationsButton } from 'features/notifications';
import SuperadminBonusSistemMenuWidget from 'features/promotions/SuperadminBonusSistem/widgets/SuperadminBonusSistemMenuWidget/SuperadminBonusSistemMenuWidget';
import { languages } from 'services/locale';

import hamburgerSVG from 'shared/img/hamburger.svg';
import logoSVG from 'shared/img/logo.svg';
import { ROLE_CASHIER } from 'shared/utils/roleBasedLocale';

// import promotionEngImage from './img/menu-eng.webp';
// import promotionFrImage from './img/menu-fr.webp';
import cashiersTournamentButtonEN from './img/btn.png';
import cashiersTournamentButtonFR from './img/btn-fr.png';

import UserInfo from './UserInfo';
import SideMenu from './SideMenu';
import './SlideOut.scss';


const b = block('slide-out');

const SlideOut = ({ children }) => {
  const dispatch = useDispatch();
  const role = useSelector(state => state.auth.role, shallowEqual);
  const lang = useSelector(state => state.locale.lang);

  const { sideMenuOpened } = useSelector(state => state.app, shallowEqual);

  const { cashiersTournament2 } = useSelector(state => state.locale.locale, shallowEqual);

  const handleHamburgerClick = () => {
    dispatch(appActions.changeSideMenuOpened(!sideMenuOpened));
  };

  return (
    <div id="slide-out" className={b({ open: sideMenuOpened })}>
      <div className={b('menu')}>
        <div className={b('header')}>
          <SVG className={b('hamburger')} svgProps={{ svg: hamburgerSVG }} onClick={handleHamburgerClick} />
          <Link to="/" onClick={handleHamburgerClick} className={b('logo-wrapper')}>
            <SVG className={b('logo')} svgProps={{ svg: logoSVG }} />
          </Link>
          <NotificationsButton inBurger />
        </div>
        <div className={b('items')}>
          <UserInfo onClick={handleHamburgerClick} />
          <SuperadminBonusSistemMenuWidget />
          {role >= ROLE_CASHIER && (
            <Link to="/cashiers-tournament" onClick={handleHamburgerClick} className={b('cashiers-tournament')}>
              <img
                src={lang === languages.FR ? cashiersTournamentButtonFR : cashiersTournamentButtonEN}
                alt={cashiersTournament2.sideTitle}
              />
            </Link>
          )}
          <SideMenu />
        </div>
      </div>
      <div className={b('content')}>{children}</div>
    </div>
  );
};

SlideOut.propTypes = {
  children: PropTypes.array.isRequired,
};

export default SlideOut;
